import { DirectiveBinding } from 'vue'

const Move = {
  // 绑定元素的父组件挂载时调用
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // 获取传入的位置参数
    const position = binding.value && binding.value.position ? binding.value.position : {}
    const { top, left, bottom, right, unit = 'px' } = position
    // 设置初始位置
    if (top !== undefined) {
      el.style.top = `${top}${unit}`
    }
    if (left !== undefined) {
      el.style.left = `${left}${unit}`
    }
    if (bottom !== undefined) {
      el.style.bottom = `${bottom}${unit}`
    }
    if (right !== undefined) {
      el.style.right = `${right}${unit}`
    }

    // 获取是否启用拖动的属性
    const isDraggable = binding.value && binding.value.draggable !== undefined ? binding.value.draggable : true

    // 如果 isDraggable 为 false，则不进行后续操作
    if (!isDraggable) {
      return
    }

    const dragBox = el // 获取当前元素
    const boundary = binding.modifiers?.boundary ?? false // 是否控制边界
    const callback =
      binding.value ??
      ((arg: any) => {
        return null
      })
    const x = el.getAttribute('dht-move-x') !== 'false'
    const y = el.getAttribute('dht-move-y') !== 'false'

    dragBox.style.position = 'fixed'
    const pdom = dragBox.parentNode as HTMLElement
    // boundary && (pdom.style.position = 'relative')
    // 父元素宽高
    const pw = pdom.offsetWidth
    const ph = pdom.offsetHeight
    // 本身宽高
    const sw = dragBox.offsetWidth
    const sh = dragBox.offsetHeight * 2 // 在控制父边界情况下避免元素超出范围
    // 计算得到最大移动距离
    const maxw = pw - sw + dragBox.offsetLeft
    const maxh = ph - sh + dragBox.offsetHeight
    const minw = 0
    const minh = 0

    dragBox.onmousedown = (e) => {
      // 检查事件目标是否为input或textarea元素
      const target = e.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.contentEditable === 'true') {
        return // 如果是输入元素，则不执行拖拽逻辑
      }

      // 阻止默认事件，避免元素选中
      e.preventDefault()
      dragBox.style.cursor = 'move'
      // 算出鼠标当前相对元素的位置
      const disX = e.x - dragBox.offsetLeft
      const disY = e.y - dragBox.offsetTop

      document.onmousemove = (e2) => {
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e2.clientX - disX
        let top = e2.clientY - disY
        // 相对于父元素的移动百分比
        let percentX = 0
        let percentY = 0
        // 当传入true代表控制边界
        if (boundary) {
          left = left > maxw ? maxw : left < minw ? minw : left
          top = top > maxh ? maxh : top < minh ? minh : top
          // 计算移动百分比
          percentX = Number(((left / maxw) * 100).toFixed(2))
          percentY = Number(((top / maxh) * 100).toFixed(2))
        }

        // 移动当前元素
        if (x) {
          if (left <= 0) {
            left = 0
          }
          dragBox.style.left = left + 'px'
          // 清除可能存在的right样式，避免冲突
          dragBox.style.right = 'auto'
        }
        if (y) {
          if (top <= 0) {
            top = 0
          }
          dragBox.style.top = top + 'px'
          // 清除可能存在的bottom样式，避免冲突
          dragBox.style.bottom = 'auto'
        }

        // callback({ left, top, percentX, percentY })
      }
      document.onmouseup = (updom) => {
        // 鼠标弹起来的时候不再移动
        document.onmousemove = null
        document.onmouseup = null
        dragBox.style.cursor = 'default'
      }
    }
  }
}

export default Move
